import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BuildIcon from '@mui/icons-material/Build';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import NotificationsIcon from '@mui/icons-material/Notifications';
import OfflineShareIcon from '@mui/icons-material/OfflineShare';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ReviewsIcon from '@mui/icons-material/Reviews';
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import UpdateIcon from '@mui/icons-material/Update';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Alert, Avatar, Box, Button, Paper, Snackbar, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi, postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import { getUserListApi, postUploadAgendaFileApi, postUploadArchiveFileApi, deleteArchiveFileApi } from 'api/meeting';
import { sendMailByMeetingIdPDFApi } from 'api/notification';
import AddUpdateMeetingDialog from 'app/components/Dialog/AddUpdateMeetingDialog';
import MeetingUsersDialog from 'app/components/Dialog/MeetingUsersDialog';
import NotificationDialog from 'app/components/Dialog/NotificationDialog';
import PreviewMeetingDialog from 'app/components/Dialog/PreviewMeetingDialog';
import PdfPreviewDialog from 'app/components/Dialog/PdfPreviewDialog';
import ReportMenuGroup from 'app/components/ReportMenuGroup';
import VideoMenuGroup from 'app/components/VideoMenuGroup';
import { getLocaleDateWithTimeCustom, getMeetingArchivePdfUrl, getUnitName, getUserFullName, highlightText, isRoleCheckList, sortByProperty } from 'app/utils/appHelpers';
import { CRON_DATA, DECISION, MEETING_USER, MEETINGS } from 'app/utils/constants/customConstant';
import config from 'config';
import { actionGroupColors, meetingSoftActiveGreen, memberParticipantHoverColor, reminderColor, statusTone } from 'app/themes/main/default';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { setCurrentAgenda, setCurrentAgendaList, setCurrentMeeting, setCurrentMeetingParticipants, setCurrentMeetingReviewList, setCurrentMeetingUsers, setCurrentMeetingVoteList } from 'stores/meeting';
import Swal from 'sweetalert2';
import LoadingPopUp from 'app/components/LoadingPopup';
import MeetingDataTableFilter from './MeetingDataTableFilter';
import MeetingDataTableToolbar from "./MeetingDataTableToolbar";

const actionChipSx = (bg) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
    padding: '3px',
    borderRadius: '9px',
    backgroundColor: bg,
});

const actionDividerSx = {
    width: '1px',
    height: '20px',
    backgroundColor: '#E3E6EB',
    marginLeft: '8px',
    marginRight: '8px',
    flexShrink: 0,
};

const actionIconButtonSx = (color) => ({
    width: 28,
    height: 28,
    minWidth: 28,
    padding: 0,
    borderRadius: 0,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color,
    '&:hover': { backgroundColor: 'transparent', boxShadow: 'none' },
    '&.Mui-disabled': { color, opacity: 1, backgroundColor: 'transparent' },
    '& .MuiTouchRipple-root': { display: 'none' },
    '& .MuiSvgIcon-root': { fontSize: 16, color: 'inherit' },
});

const memberIconSx = {
    ...actionIconButtonSx('action.active'),
    '&:hover': { backgroundColor: 'transparent', color: memberParticipantHoverColor },
};

/** Açık veya bağlantı varken yumuşak yeşil, kapalıyken gri */
const softActiveStatusColor = (isActive, disabled) => {
    const base = isActive ? meetingSoftActiveGreen : statusTone.inactive;
    return disabled ? `${base}66` : base;
};

const menuTriggerSx = (color) => ({
    display: 'inline-flex',
    '& .MuiIconButton-root': {
        width: 28,
        height: 28,
        padding: 0,
        borderRadius: 0,
        color,
        backgroundColor: 'transparent',
        '&:hover': { backgroundColor: 'transparent' },
    },
    '& .MuiTouchRipple-root': { display: 'none' },
    '& .MuiSvgIcon-root': { fontSize: 16, color: 'inherit' },
});

function MeetingDataTable({ column, pageTitle, mainData, listTotal, onQueryChange }) {

    const dispatch = useDispatch();
    const authUser = useSelector(state => state.auth.authUser);
    const userRoles = authUser && authUser.userRoles;

    const pageType = useSelector((state) => state.meeting.pageType);
    const { data: userList } = useSelector(state => state.user);

    const urlInstParam = new URLSearchParams(window.location.search).get('inst');
    const urlInst = config.insts.includes(urlInstParam) ? urlInstParam : null;

    const [data, setData] = useState([]);
    const [order, setOrder] = useState("desc");
    const [orderBy, setOrderBy] = useState("pdate");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [appliedFilters, setAppliedFilters] = useState(() => (
        urlInst ? { insts: [urlInst] } : {}
    ));
    const [reloadKey, setReloadKey] = useState(0);
    const lastQueryRef = useRef('');
    const [addMeetingDialogStatus, setAddMeetingDialogStatus] = useState(false);
    const [dialogStartTab, setDialogStartTab] = useState(0);
    const [userType, setUserType] = useState("");
    const [userListData, setUserListData] = useState([]);
    const [openUserList, setOpenUserList] = useState(false);
    const unitList = useSelector(state => state.unit.data || []);
    const [previewMeetingDialogStatus, setPreviewMeetingDialogStatus] = useState(false);
    const [selectedPreviewMeeting, setSelectedPreviewMeeting] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [highlightQuery, setHighlightQuery] = useState('');
    const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);
    const [notificationMeeting, setNotificationMeeting] = useState(null);
    const [notificationOption, setNotificationOption] = useState('review');
    const [archivePreviewMeeting, setArchivePreviewMeeting] = useState(null);
    const archiveFileInputRef = useRef(null);
    const archiveTargetMeetingRef = useRef(null);
    const [busy, setBusy] = useState(false);
    const [flashRowId, setFlashRowId] = useState(null);
    const flashTimerRef = useRef(null);

    const withBusy = async (fn) => {
        setBusy(true);
        try {
            await fn();
        } finally {
            setBusy(false);
        }
    };

    /** Geçici satır vurgusu (flash highlight): satırı kısa süre işaretler, sonra siler */
    const flashRow = (id) => {
        if (id == null) return;
        if (flashTimerRef.current) {
            clearTimeout(flashTimerRef.current);
        }
        setFlashRowId(id);
        flashTimerRef.current = setTimeout(() => {
            setFlashRowId(null);
            flashTimerRef.current = null;
        }, 1600);
    };

    useEffect(() => {
        return () => {
            if (flashTimerRef.current) {
                clearTimeout(flashTimerRef.current);
            }
        };
    }, []);

    const isManagementPage = pageType && (pageType === "1" || pageType === "3");

    useEffect(() => {
        setPage(0);
    }, [pageType]);

    useEffect(() => {
        if (!onQueryChange) return;
        const nextQuery = {
            page: rowsPerPage === -1 ? 0 : page,
            limit: rowsPerPage,
            q: searchQuery,
            sortBy: orderBy,
            sortOrder: order,
            filters: appliedFilters,
            reloadKey,
        };
        const key = JSON.stringify(nextQuery);
        if (lastQueryRef.current === key) return;
        lastQueryRef.current = key;
        onQueryChange(nextQuery);
    }, [page, rowsPerPage, searchQuery, order, orderBy, appliedFilters, reloadKey]);

    useEffect(() => {
        setData(mainData);
    }, [mainData]);

    const handleUserListButtonClick = async (id, type) => {

        try {
            let data = await getUserListApi(id, userList);

            data = data.filter(x => x.type === type)
            setUserListData(data);
        } catch (error) {
            console.error("Kullanıcı listesi alınamadı:", error);
        } finally {
            if (type === 1) {
                setUserType("Toplantının Üyeleri")
            } else {
                setUserType("Toplantının Katılımcıları")
            }
        }
        setOpenUserList(true);

    };

    const afterUpdateFunc = (item) => {

        let tmp = [...data];
        const index = data.findIndex(x => x.id === item.id);
        index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(data[data.length - 1].id) + 1 })

        setData([...tmp]);
        if (item.active === 0) {
            setReloadKey((k) => k + 1);
        } else {
            flashRow(item.id);
        }

    }

    const updateDecisionCount = (meetingId, count) => {
        setData((prev) => {
            const index = prev.findIndex((x) => x.id === meetingId);
            if (index === -1) return prev;
            if (Number(prev[index].decisionCount) === Number(count)) return prev;
            const tmp = [...prev];
            tmp[index] = { ...tmp[index], decisionCount: count };
            return tmp;
        });
    }

    const addAfterTable = (meeting) => {
        let tmp = [...data];
        tmp.unshift(meeting);
        setData([...tmp]);
        setPage(0);
        setReloadKey((k) => k + 1);
        flashRow(meeting.id);
    }

    const closeDialog = () => {
        setDialogStartTab(0);
        setAddMeetingDialogStatus(false);
    };

    const handlePreviewButtonClick = async (meeting) => {
        setSelectedPreviewMeeting(meeting);
        setPreviewMeetingDialogStatus(true)
    }

    const uploadArchiveFile = async (meeting, file) => {
        await withBusy(async () => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('meetingId', meeting.id);
            formData.append('adminUserId', authUser.id);
            formData.append('inst', meeting.inst);
            const res = await postUploadArchiveFileApi(formData);
            if (res.status) {
                afterUpdateFunc({ ...meeting, archiveFileId: res.data.id, archiveFileName: res.data.archiveFileName });
                if (archivePreviewMeeting && archivePreviewMeeting.id === meeting.id) {
                    setArchivePreviewMeeting({ ...meeting, archiveFileId: res.data.id, archiveFileName: res.data.archiveFileName });
                }
                NotificationManager.success('Arşiv yüklendi.', '', 2000);
            } else {
                NotificationManager.error(res.errorMessage || 'Arşiv yüklenemedi.', '', 3000);
            }
        });
    };

    const handleArchiveIconClick = (meeting) => {
        if (!meeting.archiveFileId) {
            archiveTargetMeetingRef.current = meeting;
            archiveFileInputRef.current.click();
            return;
        }
        setArchivePreviewMeeting(meeting);
    };

    const handleArchiveReplace = () => {
        archiveTargetMeetingRef.current = archivePreviewMeeting;
        archiveFileInputRef.current.click();
    };

    const handleArchiveDelete = async () => {
        const del = await Swal.fire({
            title: 'Silme onayı',
            text: 'Arşiv silinecek. Emin misiniz?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Evet, sil',
            cancelButtonText: 'Vazgeç'
        });
        if (!del.isConfirmed) return;
        const meeting = archivePreviewMeeting;
        await withBusy(async () => {
            const res = await deleteArchiveFileApi(meeting.archiveFileId, meeting.inst, meeting.id);
            if (res.status) {
                afterUpdateFunc({ ...meeting, archiveFileId: null, archiveFileName: null });
                setArchivePreviewMeeting(null);
                NotificationManager.success('Arşiv silindi.', '', 2000);
            } else {
                NotificationManager.error(res.errorMessage || 'Arşiv silinemedi.', '', 3000);
            }
        });
    };

    const handleArchiveFileInputChange = async (e) => {
        const file = e.target.files[0];
        e.target.value = '';
        if (!file) return;
        await uploadArchiveFile(archiveTargetMeetingRef.current, file);
    };

    const GUNDEMLER_SEKME = 3;

    const openMeetingDialog = async (meeting, startTab) => {
        let mUsers = [];
        const resultMeetingMembers = await getObjectListByPropertyApi(MEETING_USER, "meetingId", meeting.id);
        const meetingMembers = sortByProperty(resultMeetingMembers.data, "indexNo");
        meetingMembers.forEach(element => {
            const user = userList.find(item => item.id === element.userId);
            mUsers.push(user);
            element.user = user;
        });

        const updatedMeeting = {
            ...meeting,
            users: mUsers,
        };

        dispatch(setCurrentMeeting(updatedMeeting));
        dispatch(setCurrentMeetingUsers(meetingMembers.filter(x => x.type === 1)));
        dispatch(setCurrentMeetingParticipants(meetingMembers.filter(x => x.type === 2)));
        dispatch(setCurrentAgenda(null));
        dispatch(setCurrentAgendaList([]));
        dispatch(setCurrentMeetingReviewList(null));
        dispatch(setCurrentMeetingVoteList(null));

        setDialogStartTab(startTab);
        setAddMeetingDialogStatus(true);
    }

    const handleUpdateButtonClick = async (meeting) => {
        await openMeetingDialog(meeting, 0);
    }

    const handleQuickAgendaClick = async (meeting) => {
        await openMeetingDialog(meeting, GUNDEMLER_SEKME);
    }

    const handleDeleteButtonClick = async (meeting) => {

        Swal.fire({
            title: "Toplantı Silme",
            text: "Toplantıyı silmek istediğinizden emin misiniz?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet',
            cancelButtonText: "Vazgeç"
        }).then(async (result) => {
            if (result.isConfirmed) {
                await withBusy(async () => {
                    let decisionList = await getObjectListByPropertyApi(DECISION, "meetingId", meeting.id)
                    if (decisionList.data.length > 0) {
                        NotificationManager.error("Toplantıya ait gündemler olduğundan silinemez. Lütfen önce gündemleri siliniz.", '', 3000);
                        return;
                    }

                    const { user, users, decisionCount, isThereReminder, archiveFileId, archiveFileName, ...meetingObj } = meeting;
                    meetingObj.active = 0;
                    meetingObj.adminUserId = authUser.id;
                    const result = await putUpdateObjectApi(MEETINGS, meetingObj);

                    if (result.status) {
                        afterUpdateFunc && afterUpdateFunc({ ...meetingObj, archiveFileId, archiveFileName, decisionCount, isThereReminder });
                        NotificationManager.success('İşlem başarılı.', '', 2000);
                    }
                });
            }
        })

    }

    const deleteActiveCrons = async (meetingCopy, optionType = null) => {
        const existingCronRes = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meetingCopy.id);
        const list = (existingCronRes?.data || [])
            .filter((x) => x.status === 1)
            .filter((x) => (optionType ? x.optionType === optionType : true));

        for (const item of list) {
            const res = await deleteObjectApi(CRON_DATA, item.id);
            if (res.status) {
                meetingCopy.isThereReminder = "0";
            }
        }
    };

    const actionButtonsClick = async (meetingObj, option) => {

        let meetingCopy = { ...meetingObj };
        let title = "";
        let text = "";

        if (option === "review") {
            if (meetingCopy.statReview === 0) {
                title = "Değerlendirme Başlatma";
                text = "Değerlendirmeyi başlatmak";
                meetingCopy.statReview = 1;
            } else {
                title = "Değerlendirmeyi Sonlandırma";
                text = "Değerlendirmeyi sonlandırmak";
                meetingCopy.statReview = 0;
                meetingCopy.statReviewMessage = 0;
            }
        } else if (option === "vote") {
            if (meetingCopy.statVote === 0) {
                title = "Oylama Başlatma";
                text = "Oylamayı başlatmak";
                meetingCopy.statVote = 1;
            } else {
                title = "Oylama Sonlandırma";
                text = "Oylamayı sonlandırmak";
                meetingCopy.statVote = 0;
                meetingCopy.statVoteMessage = 0;
            }
        } else if (option === "video") {
            if (meetingCopy.statVideoCall === 0) {
                title = "Video Başlatma";
                text = "Video başlatmak";
                meetingCopy.statVideoCall = 1;
            } else {
                title = "Video Sonlandırma";
                text = "Video sonlandırmak";
                meetingCopy.statVideoCall = 0;
            }
        } else if (option === "finish") {
            if (meetingCopy.statFinish === 0) {
                title = "Toplantı Güncelleme Tamamlama";
                text = "Toplantı güncellemelerinin tamamlanmasını";
                meetingCopy.statFinish = 1;
            } else {
                title = "Toplantı Güncelleme Açma";
                text = "Toplantı güncellemelerini açmayı";
                meetingCopy.statFinish = 0;
            }
        }

        const isStarting = (
            (option === "review" && meetingCopy.statReview === 1) ||
            (option === "vote" && meetingCopy.statVote === 1) ||
            (option === "video" && meetingCopy.statVideoCall === 1) ||
            (option === "finish" && meetingCopy.statFinish === 1)
        );

        if (!isStarting) {
            Swal.fire({
                title,
                text: text + " istediğinize emin misiniz?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Evet',
                cancelButtonText: 'Vazgeç'
            }).then(async (result) => {
                if (!result.isConfirmed) return;

                await withBusy(async () => {
                    try {
                        if (option === "vote" || option === "review") {
                            await deleteActiveCrons(meetingCopy, option);
                        }
                        meetingCopy.adminUserId = authUser.id;
                        let { user, users, decisionCount, isThereReminder, archiveFileId, archiveFileName, ...updatedMeetingObj } = meetingCopy;
                        const res = await putUpdateObjectApi(MEETINGS, updatedMeetingObj);
                        if (res.status) {
                            afterUpdateFunc && afterUpdateFunc(meetingCopy);
                            NotificationManager.success('İşlem başarılı.', '', 1500);
                        }
                    } catch (err) {
                        NotificationManager.error(err.message || 'Beklenmedik bir hata.', '', 3000);
                    }
                });
            });
            return;
        }

        setNotificationMeeting(meetingCopy);
        setNotificationOption(option);
        setNotificationDialogOpen(true);
    };

    const processMeetingAction = async (meetingCopy, option, email, sms, agenda, decision, reminderType, mailText, smsText, extraFile) => {
        await withBusy(async () => {
            try {
                if (option === 'finish') {
                    await deleteActiveCrons(meetingCopy);
                }

                const notType = email && sms
                    ? 'mailSms'
                    : email
                        ? 'mail'
                        : sms
                            ? 'sms'
                            : "false";
                const attachmentType = agenda && decision
                    ? 'agendaDecision'
                    : agenda
                        ? 'agenda'
                        : decision
                            ? 'decision'
                            : "false";

                let extraFileId;
                let extraFileExt;
                if (extraFile) {
                    const formData = new FormData();
                    formData.append('file', extraFile);
                    formData.append('fileType', extraFile.name);
                    formData.append('adminUserId', authUser.id);
                    formData.append('decisionId', 0);
                    formData.append('meetingId', meetingCopy.id);
                    formData.append('inst', meetingCopy.inst);
                    const uploadRes = await postUploadAgendaFileApi(formData);
                    if (!uploadRes.status) {
                        NotificationManager.error('Dosya yüklenemedi', '', 3000);
                        return;
                    }
                    extraFileId = uploadRes.data[0].id;
                    extraFileExt = uploadRes.data[0].ext;
                }

                await sendMailByMeetingIdPDFApi(
                    meetingCopy.id,
                    option,
                    notType,
                    attachmentType,
                    mailText,
                    smsText,
                    extraFileId,
                    extraFileExt,
                    extraFile && extraFile.name,
                    meetingCopy.inst
                );

                meetingCopy.adminUserId = authUser.id;
                let { user, users, decisionCount, isThereReminder, archiveFileId, archiveFileName, ...updatedMeetingObj } = meetingCopy;
                if (option === 'vote') {
                    updatedMeetingObj.statVoteMessage = 1;
                }
                if (option === 'review') {
                    updatedMeetingObj.statReviewMessage = 1;
                }

                if (reminderType) {
                    const meetingReminderRes = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meetingCopy.id)

                    if (meetingReminderRes.status) {
                        let meetingReminderData = meetingReminderRes.data;

                        if (meetingReminderData.length > 0) {
                            let isThereReminder = meetingReminderData.filter(x => x.optionType === option && x.status === 1)
                            if (isThereReminder.length > 0) {
                                NotificationManager.warning('Daha önce bir hatırlatma oluşturulduğudan hatırlatma eklenemedi. Diğer işlemler başarılı', '', 3000);
                                return;
                            }
                        }

                        const tzOffsetMs = new Date().getTimezoneOffset() * 60 * 1000;
                        const nextRun = new Date(Date.now() + 24 * 60 * 60 * 1000 - tzOffsetMs);

                        const cronData = {
                            meetingId: meetingCopy.id,
                            optionType: option,
                            reminderType: reminderType,
                            status: 1,
                            lastRun: null,
                            nextRun: nextRun,
                            createdAt: new Date(Date.now() - tzOffsetMs)
                        };
                        const res = await postSaveObjectApi(CRON_DATA, cronData);
                        if (res.status) {
                            let reminderNames = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meetingCopy.id);
                            if (reminderNames.status) {
                                let reminderNamesData = reminderNames.data;
                                if (reminderNamesData.length > 0) {
                                    meetingCopy.isThereReminder = reminderNamesData.map(x => x.optionType).join(',');
                                }
                            }
                        }
                    }
                }

                const updateRes = await putUpdateObjectApi(MEETINGS, updatedMeetingObj);
                if (updateRes.status) {
                    afterUpdateFunc && afterUpdateFunc(meetingCopy);
                }

                NotificationManager.success('İşlem başarılı.', '', 2000);

            } catch (err) {
                NotificationManager.error(err.message || 'Beklenmedik bir hata.', '', 3000);
            }
        });
    };

    const handleNotificationConfirm = async ({ email, sms, agenda, decision, reminderType, mailText, smsText, extraFile }) => {
        if (!notificationMeeting) return;
        await processMeetingAction(
            notificationMeeting,
            notificationOption,
            email,
            sms,
            agenda,
            decision,
            reminderType,
            mailText,
            smsText,
            extraFile
        );
    };

    const handleCopyMeetingUrl = async (url) => {

        try {
            await navigator.clipboard.writeText(url);
            setSnackbarMessage("Toplantı bağlantısı kopyalandı!");
            setCopySuccess(true);
        } catch (err) {
            console.error("Kopyalama işlemi başarısız!", err);
            setSnackbarMessage("Kopyalama işlemi başarısız!");
            setCopySuccess(true);
        }
    };

    const NON_SORTABLE_COLUMNS = ['delete', 'decisionCount', 'userParticipantList', 'buttons', 'islemler'];

    const handleRequestSort = (event, property) => {
        if (!['inst', 'unit', 'meetingNo', 'pdate', 'adminUserId', 'statFinish'].includes(property)) {
            return;
        }
        const tempOrderBy = property;
        let tempOrder = 'desc';

        if (orderBy === property && order === 'desc') {
            tempOrder = 'asc';
        }

        setOrder(tempOrder);
        setOrderBy(tempOrderBy);
        setPage(0);
    };

    const DataTableHead = ({ onRequestSort, customColumnData }) => {

        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {customColumnData.map(column => {
                        if (NON_SORTABLE_COLUMNS.includes(column.id)) {
                            return (
                                <TableCell
                                    key={column.id}
                                    align={column.align || 'center'}
                                    padding={column.disablePadding ? 'none' : 'normal'}
                                    sx={{ whiteSpace: 'normal' }}
                                >
                                    {column.id === 'delete' ? null : column.label}
                                </TableCell>
                            );
                        }
                        return (
                            <TableCell
                                key={column.id}
                                align={column.numeric}
                                padding={column.disablePadding ? 'none' : 'normal'}
                                sx={{ whiteSpace: 'normal' }}
                            >
                                <Tooltip
                                    title="Sırala"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={createSortHandler(column.id)}
                                        sx={{ whiteSpace: 'normal', '& .MuiTableSortLabel-icon': { flexShrink: 0 } }}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    };

    const getReminderMessage = (isThereReminder) => {
        if (!isThereReminder || isThereReminder === '0') {
            return '';
        }

        const reminderTypes = isThereReminder.split(',').map(type => type.trim());

        if (reminderTypes.length === 1) {
            if (reminderTypes[0] === 'vote') {
                return 'Oylama için hatırlatma bulunmaktadır. Hatırlatıcıyı kaldırmak için tıklayınız';
            } else if (reminderTypes[0] === 'review') {
                return 'Değerlendirme için hatırlatma bulunmaktadır. Hatırlatıcıyı kaldırmak için tıklayınız';
            }
        } else if (reminderTypes.length === 2) {
            if (reminderTypes.includes('vote') && reminderTypes.includes('review')) {
                return 'Oylama ve değerlendirme için hatırlatma bulunmaktadır. Hatırlatıcıyı kaldırmak için tıklayınız';
            }
        }

        return 'Hatırlatma bulunmaktadır. Hatırlatıcıyı kaldırmak için tıklayınız';
    };

    const handleRemoveReminder = async (meeting) => {
        try {
            const reminderTypes = meeting.isThereReminder.split(',').map(type => type.trim());

            let selectedReminders = [];
            let confirmationText = '';

            if (reminderTypes.length === 1) {
                if (reminderTypes[0] === 'vote') {
                    confirmationText = 'Oylama hatırlatıcısını kaldırmak istediğinizden emin misiniz?';
                } else if (reminderTypes[0] === 'review') {
                    confirmationText = 'Değerlendirme hatırlatıcısını kaldırmak istediğinizden emin misiniz?';
                }
                selectedReminders = reminderTypes;
            } else if (reminderTypes.length === 2) {
                const { value: formValues } = await Swal.fire({
                    title: 'Hatırlatıcı Seçimi',
                    html: `
                        <div style="text-align: left; margin: 20px 0;">
                            <div style="margin-bottom: 15px;">
                                <label style="display: flex; align-items: center; cursor: pointer;">
                                    <input type="checkbox" id="vote-checkbox" style="margin-right: 10px;" checked>
                                    <span>Oylama Hatırlatıcısı</span>
                                </label>
                            </div>
                            <div>
                                <label style="display: flex; align-items: center; cursor: pointer;">
                                    <input type="checkbox" id="review-checkbox" style="margin-right: 10px;" checked>
                                    <span>Değerlendirme Hatırlatıcısı</span>
                                </label>
                            </div>
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Evet, Kaldır',
                    cancelButtonText: 'Vazgeç',
                    focusConfirm: false,
                    preConfirm: () => {
                        const voteChecked = document.getElementById('vote-checkbox').checked;
                        const reviewChecked = document.getElementById('review-checkbox').checked;

                        if (!voteChecked && !reviewChecked) {
                            Swal.showValidationMessage('En az bir hatırlatıcı seçmelisiniz');
                            return false;
                        }

                        return {
                            vote: voteChecked,
                            review: reviewChecked
                        };
                    }
                });

                if (formValues) {
                    if (formValues.vote && formValues.review) {
                        selectedReminders = ['vote', 'review'];
                        confirmationText = 'Oylama ve değerlendirme hatırlatıcılarını kaldırmak istediğinizden emin misiniz?';
                    } else if (formValues.vote) {
                        selectedReminders = ['vote'];
                        confirmationText = 'Oylama hatırlatıcısını kaldırmak istediğinizden emin misiniz?';
                    } else if (formValues.review) {
                        selectedReminders = ['review'];
                        confirmationText = 'Değerlendirme hatırlatıcısını kaldırmak istediğinizden emin misiniz?';
                    }
                } else {
                    return; // Kullanıcı iptal etti
                }
            }

            const result = await Swal.fire({
                title: 'Hatırlatıcıyı Kaldır',
                text: confirmationText,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Evet, Kaldır',
                cancelButtonText: 'İptal'
            });

            if (result.isConfirmed) {
                await withBusy(async () => {
                    let updatedMeeting = { ...meeting };
                    let currentReminders = updatedMeeting.isThereReminder.split(',').map(type => type.trim());

                    const cronDataResponse = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meeting.id);

                    if (cronDataResponse.status && cronDataResponse.data.length > 0) {
                        for (const cronItem of cronDataResponse.data) {
                            if (selectedReminders.includes(cronItem.optionType)) {
                                const res = await deleteObjectApi(CRON_DATA, cronItem.id);
                                if (res.status) {
                                    currentReminders = currentReminders.filter(type => type !== cronItem.optionType);
                                }
                            }
                        }
                    }

                    updatedMeeting.isThereReminder = currentReminders.length > 0 ? currentReminders.join(',') : '0';

                    let tmp = [...data];
                    const index = data.findIndex(x => x.id === meeting.id);
                    if (index !== -1) {
                        tmp[index] = updatedMeeting;
                        setData([...tmp]);
                    }

                    afterUpdateFunc(updatedMeeting);

                    let successMessage = '';
                    if (selectedReminders.length === 1) {
                        if (selectedReminders[0] === 'vote') {
                            successMessage = 'Oylama hatırlatıcısı başarıyla kaldırıldı.';
                        } else if (selectedReminders[0] === 'review') {
                            successMessage = 'Değerlendirme hatırlatıcısı başarıyla kaldırıldı.';
                        }
                    } else if (selectedReminders.length === 2) {
                        successMessage = 'Oylama ve değerlendirme hatırlatıcıları başarıyla kaldırıldı.';
                    }

                    NotificationManager.success(successMessage, '', 2000);
                });
            }
        } catch (error) {
            NotificationManager.error(error.message || 'Hatırlatıcı kaldırılırken bir hata oluştu.', '', 3000);
        }
    };

    return (

        <Paper className="col-md-12" sx={{ minWidth: 0, overflow: 'hidden' }}>
            <>
                <LoadingPopUp open={busy} blocking message="" />

                <MeetingDataTableToolbar
                    pageTitle={pageTitle}
                    afterUpdateFunc={afterUpdateFunc}
                    addAfterTable={addAfterTable}
                    updateDecisionCount={updateDecisionCount}
                    isManagementPage={isManagementPage}
                    setHighlightQuery={setHighlightQuery}
                    onSearchSubmit={(q) => {
                        setSearchQuery(q);
                        setPage(0);
                    }}
                />
                <MeetingDataTableFilter
                    initialInst={urlInst}
                    onApplyFilters={(filters) => {
                        setAppliedFilters(filters);
                        setPage(0);
                    }}
                    onClearFilters={() => {
                        setAppliedFilters({});
                        setPage(0);
                    }}
                />
                <div className="flex-auto" style={{ minWidth: 0 }}>
                    <Box sx={{ overflowX: 'auto' }}>
                        <Table
                            sx={{
                                minWidth: 960,
                                '& .MuiTableCell-head': {
                                    whiteSpace: 'normal',
                                },
                                '& .MuiTableSortLabel-root': {
                                    whiteSpace: 'normal',
                                },
                                '& .MuiTableSortLabel-icon': {
                                    flexShrink: 0,
                                }
                            }}
                            size="small"
                        >
                            <DataTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                rowCount={data.length}
                                customColumnData={column}
                            />

                            <TableBody>
                                {data.length > 0 ? (
                                    data.map(n => {
                                        const isEditable = !(n.statFinish === 1 || !isManagementPage);
                                        const canManage = isManagementPage && isRoleCheckList(userRoles, [1, 370, 373, 369, 372]);
                                        const user = userList.find(x => x.id === n.adminUserId);

                                        return (
                                            <TableRow
                                                hover
                                                key={"trO" + n.id}
                                                className={flashRowId === n.id ? 'meeting-row-flash' : undefined}
                                            >
                                                <TableCell align="left" padding="normal">
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                        {canManage && (
                                                            <Box sx={{ width: 28, minWidth: 28, height: 28, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                {isEditable && (
                                                                    <Tooltip title="Toplantı Silme" placement="top" arrow>
                                                                        <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                            <Button
                                                                                aria-label="Toplantı Silme"
                                                                                color="error"
                                                                                sx={actionIconButtonSx(actionGroupColors.danger.icon)}
                                                                                onClick={async () => {
                                                                                    await handleDeleteButtonClick(n);
                                                                                }}
                                                                            >
                                                                                <DeleteIcon />
                                                                            </Button>
                                                                        </Box>
                                                                    </Tooltip>
                                                                )}
                                                            </Box>
                                                        )}
                                                        {highlightText(n.inst, highlightQuery)}
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="left" padding="none">
                                                    {
                                                        highlightText(getUnitName(n.unitId, unitList), highlightQuery)
                                                    }
                                                </TableCell>
                                                <TableCell align="left" padding="none" sx={{ paddingLeft: 2 }}>{highlightText(`${n.meetingNo}`, highlightQuery)}</TableCell>
                                                <TableCell align="left" padding="none" >
                                                    {getLocaleDateWithTimeCustom("tr", n.pdate)}
                                                </TableCell>
                                                <TableCell align="center" padding="none">
                                                    <Box display="flex" alignItems="center" gap={1}>

                                                        <Avatar
                                                            alt=""
                                                            src={(user && user.profileImageUrl) ? config.userAuthApiUrl + user.profileImageUrl : config.userAuthApiUrl + config.defaultProfileImageUrl}
                                                            onError={(e) => { e.target.onerror = null; e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl }}

                                                        />

                                                        <span>{highlightText(getUserFullName(user), highlightQuery)}</span>
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="left" padding="none" sx={{ paddingLeft: 3 }}>{n.decisionCount}</TableCell>
                                                <TableCell align="center" padding="none">
                                                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '2px' }}>
                                                        <Tooltip title="Üyeleri görüntülemek için tıklayınız" placement="top" arrow>
                                                            <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                <Button
                                                                    aria-label="Üyeleri görüntülemek için tıklayınız"
                                                                    onClick={() => handleUserListButtonClick(n.id, 1)}
                                                                    sx={memberIconSx}
                                                                >
                                                                    <GroupsOutlinedIcon />
                                                                </Button>
                                                            </Box>
                                                        </Tooltip>
                                                        <Tooltip title="Katılımcıları görüntülemek için tıklayınız" placement="top" arrow>
                                                            <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                <Button
                                                                    aria-label="Katılımcıları görüntülemek için tıklayınız"
                                                                    onClick={() => handleUserListButtonClick(n.id, 2)}
                                                                    sx={memberIconSx}
                                                                >
                                                                    <PersonOutlineIcon />
                                                                </Button>
                                                            </Box>
                                                        </Tooltip>
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="left" padding="none">
                                                    {(() => {
                                                        const reviewTitle = n.statReview === 0 ? "Değerlendirmeyi Başlat" : "Değerlendirmeyi Sonlandır";
                                                        const reviewDisabled = !isEditable || (n.statFinish === 1 && n.statReview !== 0);
                                                        const voteTitle = n.statVote === 0 ? "Oylamayı Başlat" : "Oylamayı Sonlandır";
                                                        const voteDisabled = !isEditable || (n.statFinish === 1 && n.statVote !== 0);
                                                        const videoTitle = n.statFinish === 1 ? "" : (n.meetingUrl === '' ? "Önce toplantı bağlantısı oluşturulmalı" : (n.statVideoCall === 0 ? "Toplantı Video Konferansı Başlat" : "  Toplantı Video Konferansı Sonlandır"));
                                                        const videoDisabled = !isEditable || n.meetingUrl === '' || (n.statFinish === 1 && n.statVideoCall !== 0);
                                                        const finishTitle = n.statFinish === 0 ? "Toplantıyı Tamamla" : "Toplantıyı Güncellemeye Aç";
                                                        const finishDisabled = (!isEditable && !isManagementPage);
                                                        const copyTitle = (n.meetingUrl && n.meetingUrl !== undefined) ? "Toplantı Bağlantısını Kopyala" : "Toplantı Bağlantısı Oluşturulmamış";
                                                        const joinTitle = n.meetingUrl ? "Çevrim içi toplantıya katılmak için tıklayınız" : "Toplantı bağlantısı bulunmamaktadır";
                                                        const archiveTitle = n.archiveFileId ? "Arşiv" : "Arşiv yükle";

                                                        const statusItems = [];
                                                        if (canManage) {
                                                            statusItems.push(
                                                                <Tooltip key="review" title={reviewTitle} placement="top" arrow>
                                                                    <span style={{ cursor: reviewDisabled ? 'not-allowed' : 'pointer' }}>
                                                                        <Button
                                                                            aria-label={reviewTitle}
                                                                            variant="text"
                                                                            sx={actionIconButtonSx(softActiveStatusColor(!(n.statFinish === 1 || n.statReview === 0), reviewDisabled))}
                                                                            onClick={() => {
                                                                                if (!isEditable || (n.statFinish === 1 && n.statReview !== 0)) return;
                                                                                actionButtonsClick(n, 'review');
                                                                            }}
                                                                            disabled={reviewDisabled}
                                                                        >
                                                                            <ReviewsIcon />
                                                                        </Button>
                                                                    </span>
                                                                </Tooltip>,
                                                                <Tooltip key="vote" title={voteTitle} placement="top" arrow>
                                                                    <span style={{ cursor: voteDisabled ? 'not-allowed' : 'pointer' }}>
                                                                        <Button
                                                                            aria-label={voteTitle}
                                                                            variant="text"
                                                                            sx={actionIconButtonSx(softActiveStatusColor(!(n.statFinish === 1 || n.statVote === 0), voteDisabled))}
                                                                            onClick={() => {
                                                                                if (!isEditable || (n.statFinish === 1 && n.statVote !== 0)) return;
                                                                                actionButtonsClick(n, 'vote');
                                                                            }}
                                                                            disabled={voteDisabled}
                                                                        >
                                                                            <ThumbsUpDownIcon />
                                                                        </Button>
                                                                    </span>
                                                                </Tooltip>,
                                                                <Tooltip
                                                                    key="video"
                                                                    title={videoTitle}
                                                                    placement="top"
                                                                    arrow
                                                                    disableHoverListener={n.statFinish === 1}
                                                                    disableFocusListener={n.statFinish === 1}
                                                                    disableTouchListener={n.statFinish === 1}
                                                                >
                                                                    <span style={{ cursor: videoDisabled ? 'not-allowed' : 'pointer' }}>
                                                                        <Button
                                                                            aria-label={videoTitle || "Toplantı Video Konferansı"}
                                                                            variant="text"
                                                                            sx={actionIconButtonSx(softActiveStatusColor(!(n.statFinish === 1 || n.statVideoCall === 0), videoDisabled))}
                                                                            onClick={() => {
                                                                                if (!isEditable || n.meetingUrl === '' || (n.statFinish === 1 && n.statVideoCall !== 0)) return;
                                                                                actionButtonsClick(n, 'video');
                                                                            }}
                                                                            disabled={videoDisabled}
                                                                        >
                                                                            <VideocamIcon />
                                                                        </Button>
                                                                    </span>
                                                                </Tooltip>,
                                                                <Tooltip key="finish" title={finishTitle} placement="top" arrow>
                                                                    <span style={{ cursor: finishDisabled ? 'not-allowed' : 'pointer' }}>
                                                                        <Button
                                                                            aria-label={finishTitle}
                                                                            variant="text"
                                                                            sx={actionIconButtonSx(softActiveStatusColor(n.statFinish !== 0, finishDisabled))}
                                                                            onClick={() => actionButtonsClick(n, 'finish')}
                                                                            disabled={finishDisabled}
                                                                        >
                                                                            <DoneAllIcon />
                                                                        </Button>
                                                                    </span>
                                                                </Tooltip>
                                                            );
                                                        }

                                                        const linkItems = [];
                                                        if (isEditable) {
                                                            linkItems.push(
                                                                <Tooltip key="copy" placement="top" arrow title={copyTitle}>
                                                                    <Box component="span" sx={{ display: 'inline-flex', cursor: n.meetingUrl === "" ? 'not-allowed' : 'pointer' }}>
                                                                        <Button
                                                                            key={n.meetingUrl}
                                                                            aria-label={copyTitle}
                                                                            sx={actionIconButtonSx(softActiveStatusColor(!!n.meetingUrl, n.meetingUrl === ""))}
                                                                            disabled={n.meetingUrl === ""}
                                                                            onClick={() => handleCopyMeetingUrl(n.meetingShortUrl ? n.meetingShortUrl : n.meetingUrl)}
                                                                        >
                                                                            <OfflineShareIcon />
                                                                        </Button>
                                                                    </Box>
                                                                </Tooltip>,
                                                                <Tooltip key="join" title={joinTitle} placement="top" arrow>
                                                                    <Box component="span" sx={{ display: 'inline-flex', cursor: n.meetingUrl === "" ? 'not-allowed' : 'pointer' }}>
                                                                        <Button
                                                                            aria-label={joinTitle}
                                                                            sx={actionIconButtonSx(softActiveStatusColor(!!n.meetingUrl, n.meetingUrl === ""))}
                                                                            disabled={n.meetingUrl === ""}
                                                                            onClick={() => {
                                                                                if (n.meetingUrl) {
                                                                                    window.open(n.meetingUrl, '_blank');
                                                                                }
                                                                            }}
                                                                        >
                                                                            <VideoCameraFrontIcon />
                                                                        </Button>
                                                                    </Box>
                                                                </Tooltip>,
                                                                <Tooltip key="videoSettings" title="Video Konferans Ayarları" placement="top" arrow>
                                                                    <Box component="span" sx={menuTriggerSx(actionGroupColors.edit.icon)}>
                                                                        <VideoMenuGroup
                                                                            meeting={n}
                                                                            isEditable={isEditable}
                                                                            afterUpdateFunc={afterUpdateFunc}
                                                                        />
                                                                    </Box>
                                                                </Tooltip>
                                                            );
                                                        }

                                                        const reportItems = [
                                                            <Tooltip key="report" title="Rapor Menüsü" placement="top" arrow>
                                                                <Box component="span" sx={menuTriggerSx(actionGroupColors.edit.icon)}>
                                                                    <ReportMenuGroup meeting={n} visibleMail={isManagementPage} ariaLabel="Rapor Menüsü" />
                                                                </Box>
                                                            </Tooltip>,
                                                            <Tooltip key="preview" title="Toplantı Bilgi Önizleme" placement="top" arrow>
                                                                <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                    <Button
                                                                        aria-label="Toplantı Bilgi Önizleme"
                                                                        sx={actionIconButtonSx(actionGroupColors.edit.icon)}
                                                                        onClick={async () => {
                                                                            await handlePreviewButtonClick(n);
                                                                        }}
                                                                    >
                                                                        <VisibilityIcon />
                                                                    </Button>
                                                                </Box>
                                                            </Tooltip>,
                                                        ];

                                                        const archiveItems = [];
                                                        if (n.isArchive === 1 && (isManagementPage || n.archiveFileId)) {
                                                            archiveItems.push(
                                                                <Tooltip key="archive" title={archiveTitle} placement="top" arrow>
                                                                    <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                        <Button
                                                                            aria-label={archiveTitle}
                                                                            sx={actionIconButtonSx(meetingSoftActiveGreen)}
                                                                            onClick={() => handleArchiveIconClick(n)}
                                                                        >
                                                                            <PictureAsPdfIcon />
                                                                        </Button>
                                                                    </Box>
                                                                </Tooltip>
                                                            );
                                                        }

                                                        const updateItems = [];
                                                        if (canManage && isEditable) {
                                                            updateItems.push(
                                                                <Tooltip key="update" title="Toplantı Bilgi Güncelle" placement="top" arrow>
                                                                    <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                        <Button
                                                                            aria-label="Toplantı Bilgi Güncelle"
                                                                            sx={actionIconButtonSx(actionGroupColors.edit.icon)}
                                                                            onClick={async () => {
                                                                                await handleUpdateButtonClick(n);
                                                                            }}
                                                                        >
                                                                            <UpdateIcon />
                                                                        </Button>
                                                                    </Box>
                                                                </Tooltip>,
                                                                <Tooltip key="agenda" title="Hızlı Gündemler" placement="top" arrow>
                                                                    <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                        <Button
                                                                            aria-label="Hızlı Gündemler"
                                                                            sx={actionIconButtonSx(actionGroupColors.edit.icon)}
                                                                            onClick={() => handleQuickAgendaClick(n)}
                                                                        >
                                                                            <FormatListBulletedIcon />
                                                                        </Button>
                                                                    </Box>
                                                                </Tooltip>
                                                            );
                                                        }

                                                        const restItems = [...linkItems, ...reportItems, ...updateItems];
                                                        if (!isManagementPage && n.statFinish !== 1) {
                                                            restItems.push(
                                                                <Box
                                                                    key="unfinished-label"
                                                                    component="span"
                                                                    sx={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        px: 0.75,
                                                                        color: 'warning.main',
                                                                        fontSize: '0.75rem',
                                                                        whiteSpace: 'nowrap',
                                                                    }}
                                                                >
                                                                    Henüz Tamamlanmamış
                                                                </Box>
                                                            );
                                                        }
                                                        const groups = [
                                                            { key: 'status', bg: actionGroupColors.status.bg, items: statusItems },
                                                            { key: 'rest', bg: actionGroupColors.edit.bg, items: restItems },
                                                            { key: 'archive', bg: actionGroupColors.status.bg, items: archiveItems },
                                                        ].filter((group) => group.items.length > 0);

                                                        return (
                                                            <>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                                                                    {canManage && (
                                                                        <Box sx={{ width: 28, minWidth: 28, height: 28, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', mr: 1, flexShrink: 0 }}>
                                                                            {n.isThereReminder && n.isThereReminder !== '0' && (
                                                                                <Tooltip
                                                                                    title={getReminderMessage(n.isThereReminder)}
                                                                                    placement="top"
                                                                                    arrow
                                                                                >
                                                                                    <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                                        <Button
                                                                                            aria-label={getReminderMessage(n.isThereReminder)}
                                                                                            color="warning"
                                                                                            onClick={() => handleRemoveReminder(n)}
                                                                                            sx={actionIconButtonSx(reminderColor)}
                                                                                        >
                                                                                            <NotificationsIcon />
                                                                                        </Button>
                                                                                    </Box>
                                                                                </Tooltip>
                                                                            )}
                                                                        </Box>
                                                                    )}
                                                                    {groups.map((group, index) => (
                                                                        <Box key={group.key} sx={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                            {index > 0 ? <Box sx={actionDividerSx} /> : null}
                                                                            <Box sx={actionChipSx(group.bg)}>{group.items}</Box>
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                                <Snackbar
                                                                    open={copySuccess}
                                                                    autoHideDuration={4000}
                                                                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                                                                    onClose={() => setCopySuccess(false)}
                                                                >
                                                                    <Alert
                                                                        severity={snackbarMessage.includes("başarısız") ? "error" : "success"}
                                                                        onClose={() => setCopySuccess(false)}
                                                                    >
                                                                        {snackbarMessage}
                                                                    </Alert>
                                                                </Snackbar>
                                                            </>
                                                        );
                                                    })()}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={column.length} align="center">Toplantı Bulunamadı</TableCell>
                                    </TableRow>
                                )}
                                {
                                    <MeetingUsersDialog
                                        open={openUserList}
                                        onClose={() => setOpenUserList(false)}
                                        userListData={userListData}
                                        userType={userType}
                                    />
                                }
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={listTotal != null ? listTotal : data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={rowsPerPage === -1 ? 0 : page}
                                        onPageChange={(e, nextPage) => setPage(nextPage)}
                                        onRowsPerPageChange={(e) => {
                                            setRowsPerPage(Number(e.target.value));
                                            setPage(0);
                                        }}
                                        labelRowsPerPage={"Görüntülenecek Satır"}
                                        rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                                        showFirstButton

                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </Box>
                </div>

                <AddUpdateMeetingDialog
                    onClose={closeDialog}
                    open={addMeetingDialogStatus}
                    startTab={dialogStartTab}
                    afterUpdateFunc={afterUpdateFunc}
                    addAfterTable={addAfterTable}
                    updateDecisionCount={updateDecisionCount}
                />

                <input
                    type="file"
                    accept=".pdf"
                    ref={archiveFileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleArchiveFileInputChange}
                />

                <PreviewMeetingDialog
                    meeting={selectedPreviewMeeting}
                    onClose={() => setPreviewMeetingDialogStatus(false)}
                    open={previewMeetingDialogStatus}
                />

                <PdfPreviewDialog
                    open={Boolean(archivePreviewMeeting)}
                    onClose={() => setArchivePreviewMeeting(null)}
                    title={archivePreviewMeeting ? `${archivePreviewMeeting.inst} ${archivePreviewMeeting.unit} / ${archivePreviewMeeting.meetingNo}` : ''}
                    url={getMeetingArchivePdfUrl(archivePreviewMeeting)}
                    actions={isManagementPage ? (
                        <>
                            <Button onClick={handleArchiveReplace}>Değiştir</Button>
                            <Button color="error" onClick={handleArchiveDelete}>Sil</Button>
                        </>
                    ) : null}
                />

                <NotificationDialog
                    open={notificationDialogOpen}
                    onClose={() => setNotificationDialogOpen(false)}
                    mode="meetingAction"
                    actionType={notificationOption}
                    meeting={notificationMeeting}
                    onConfirm={handleNotificationConfirm}
                />
            </>

        </Paper >

    );

}

export default MeetingDataTable